export default __webpack_public_path__ + "static/media/SwingLegRetraction.cc67e0b5.png";